module.exports = __webpack_public_path__ + "img/icon-round-outline.3cd1592a.svg";